import { matchPath } from 'react-router-dom';

// Routes that own the full viewport and intentionally hide global app chrome.
const STANDALONE_LAYOUT_ROUTES = [
    '/brand-radar/:brandName?'
];

export function isStandaloneLayoutPath(location) {
    const pathname = (location || '').split('?')[0].split('#')[0];

    return STANDALONE_LAYOUT_ROUTES.some((path) =>
        matchPath({ path, end: true }, pathname)
    );
}
